import { Pipe } from '@angular/core';
import { formatCzSkPhone } from '@kp/utils';

import type { PipeTransform } from '@angular/core';

@Pipe({ name: 'kpFormatPhone' })
export class FormatPhonePipe implements PipeTransform {
  transform(value: string): string {
    return formatCzSkPhone(value);
  }
}
